<!--suppress UnnecessaryLabelJS -->
<template>
	<v-card>
		<v-card-title>
			<v-spacer/>
			<v-spacer/>
			<v-text-field
				v-model="freeSearch"
				append-icon="mdi-magnify"
				:label="$t('pages.orderFilter.search')"
				single-line
				hide-details
			></v-text-field>
		</v-card-title>
		<v-data-table
			:headers="headers"
			:items="areas"
			:loading="loading"
			:search.sync="freeSearch"
			class="elevation-1"
		>
			<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
			<template #item="{item}">
				<area-row :key="item.id" @edit="onEdit" :area="item"/>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>

	import {types} from "src/store/modules/Area.module";
	import FilterAble from "src/mixins/FilterAble";
	import AreaRow from "src/view/areas/AreaRow";

	export default {
		name: "areas-table",
		props: [],
		components: {
			AreaRow
		},
		mixins: [new FilterAble(types)],
		data() {
			return {
				loading: false,
				headers: [
					{text: "שם האזור", value: "name"},
					{text: "פעולות", value: "actions"},

				],
				freeSearch: null,
				showDialog: false
			};
		},
		computed: {
			areas() {
				return this.$store.state.AreaModule.areas;
			}
		},
		methods: {
			onEdit(Area) {
				this.$emit("edit", Area);
			}
		}
	};
</script>

<style>

</style>
